export default function isUrlValid() {
  const pathname = window.location.pathname.split('/');
  return pathname.length === 4 && pathname.slice(-1).toString().length === 24;
}
